export enum NotifyType {
    DoNotNotify = 0,
    Notify = 1,
    NotifyUrgently = 2,
}
